import { useFetch } from './useFetch'
import type { InventorySystemProfileDTO } from '../types'

export function useInventorySystemProfiles() {
  const { data: profiles, isLoading, error } =
    useFetch<InventorySystemProfileDTO[]>('/v1/inventory-system-profiles', [])
  return { profiles, isLoading, error }
}
